import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Theme } from '@mui/material/styles/createTheme';
import makeStyles from '@mui/styles/makeStyles';

const ModalWrapper = styled(Box)(({ theme, marginTop = -60 }) => ({
  position: 'absolute',
  left: 0,
  width: '100%',
  zIndex: 1300,
  height: '100%',
  background: theme.palette.gray.transparentGray,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    background: theme.palette.gray.transparentGray,
    marginTop,
    height: 'calc(100% + 60px)',
  },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  maxWidth: 738,
  height: '440px',
  overflow: 'scroll',
  width: '100%',
  backgroundColor: theme.palette.mainLight,
  padding: '33px',
  [theme.breakpoints.down('md')]: {
    width: 'initial',
    margin: 10,
    borderRadius: 5,
    padding: '30px 20px',
  },
}));

const TermsContainer = styled(Box)(({ theme }) => ({
  maxWidth: 'calc(100% - 65px)',
  height: "75vh",
  width: '100%',
  backgroundColor: theme.palette.mainLight,
  padding: '33px',
  [theme.breakpoints.down('lg')]: {
    width: 'initial',
    margin: 10,
    borderRadius: 5,
    padding: '30px 20px',
  },
}));

const TermsContentContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  padding:"10px 10px",
  flexDirection: "column",
  height:"100%",
  flexGrow:1,
  backgroundColor: theme.palette.mainLight,
}));


const StyledModalBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 738,
  backgroundColor: 'white',
  padding: '40px 32px 32px 32px',
  border: '1px solid',
  borderColor: theme.palette.purple.extraLight,
  borderRadius: '5px',
  outline: 'none',
  boxShadow: 'none',
  minHeight: 400,
  maxHeight: 600,
  overflow: 'scroll',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    width: '95%',
    paddingTop: 56
  },
  [theme.breakpoints.down('sm')]: {
    padding: '32px 16px'
  },
}));

const WideStyledBox = styled(StyledModalBox)(() => ({
  width: 900
}));


export const useConfirmStyles = makeStyles((theme: Theme) => ({
  goBackBtn: {
    top: 16,
    left: 10,
    position: 'absolute',
  },
  dialogTitle: {
    textAlign: 'center',
    fontFamily: 'Martel,serif',
  },
  dialogHeader: {
    borderTop: '1px solid #EEE',
  },
}));

export { ModalWrapper, ContentContainer, StyledModalBox, WideStyledBox, TermsContentContainer, TermsContainer };
